import { createAction, props } from '@ngrx/store';
import { Config } from '../../interfaces/config';
import {
  IComuni,
  IProvince,
  IRegioni,
  payloadComuni,
  payloadProvince,
} from '../../interfaces/location';
import { INotification } from '../../interfaces/notification';
import { CatalogoAppartenenza } from '../../interfaces/catalogo-appartenenza';
import { IDropdownOptions } from '@poste-click-connect/shared-ui';

export const RETRIEVE_CONFIG = createAction(
  '[CONFIG] - retrieve config',
  props<{ token: string }>()
);

export const RETRIEVE_CONFIG_SUCCESS = createAction(
  '[CONFIG] - retrieve config success',
  props<{ config: Config }>()
);

export const DOWNLOAD_FILE = createAction(
  '[CONFIG] - download file',
  props<{ file: Blob; fileName: string; blobType?: string }>()
);

export const ADD_TOAST_NOTIFICATION = createAction(
  '[CONFIG] create toast notification',
  props<{ notificationMessage: INotification | null }>()
);

export const RESET_TOAST_NOTIFICATION = createAction(
  '[CONFIG] - reset toast notification'
);

export const RETRIVE_CATALOGO_APPARTENENZA = createAction(
  '[CONFIG] - retrive catalogo appartenenza'
);

export const RETRIVE_CATALOGO_APPARTENENZA_SUCCESS = createAction(
  '[CONFIG] - retrieve catalogo appartenenza success',
  props<{ catalogoAppartenenza: IDropdownOptions<any>[] }>()
);

export const RETRIVE_CLASSE_APPARTENENZA = createAction(
  '[CONFIG] - retrive classe appartenenza',
  props<{ payload: { clusterAppartenenza: string } }>()
);

export const RETRIVE_CLASSE_APPARTENENZA_SUCCESS = createAction(
  '[CONFIG] - retrieve classe appartenenza success',
  props<{ classeAppartenenza: IDropdownOptions<any>[] | [] }>()
);

export const RETRIVE_REGIONI = createAction('[CONFIG] - retrive region');

export const RETRIVE_REGIONI_SUCCESS = createAction(
  '[CONFIG] - retrieve region success',
  props<{ regioni: IRegioni }>()
);

export const RETRIVE_PROVINCE = createAction(
  '[CONFIG] - retrive province',
  props<{ payload: payloadProvince }>()
);

export const RETRIVE_PROVINCE_SUCCESS = createAction(
  '[CONFIG] - retrieve province success',
  props<{ province: IProvince | null }>()
);

export const RETRIVE_COMUNI = createAction(
  '[CONFIG] - retrive comuni',
  props<{ payload: payloadComuni }>()
);

export const RETRIVE_COMUNI_SUCCESS = createAction(
  '[CONFIG] - retrieve comuni success',
  props<{ comuni: IComuni | null }>()
);
